import * as React from 'react';
import './BeneficiaryPayoutSlider.css';

interface BeneficiaryPayoutSliderProps {
    beneficiary: any;
    emitHandleChange: any;
}

export class BeneficiaryPayoutSlider extends React.Component<BeneficiaryPayoutSliderProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
            percentage: props.beneficiary.percentage,
        }
        
        this.handleEmitChange = this.handleEmitChange.bind(this);
        this.handleRangeChange = this.handleRangeChange.bind(this);
    }
    
    handleEmitChange(percentage) {
        this.props.emitHandleChange(percentage, this.props.beneficiary);
    }

    changeEdit() {
        this.setState({ isInEdit: !this.state.isInEdit });
    }
    
    handleRangeChange(e) {
        this.setState({
            percentage: e.target.value
        })
        
        this.handleEmitChange(e.target.value);
    }
    
    public render() {
        const { beneficiary } = this.props;
        return (
            <div className="beneficiary-update-policy-payout__block row flex-column justify-content-center align-items-end">
                <input type="range" onChange={this.handleRangeChange} value={beneficiary.percentage} min="1" max="100" />
            </div>
        )
    }
}